// Twin of packages/ui/src/styles/brand-tokens.css, for where a CSS variable cannot reach (SVG attributes, emails).
export const BRAND_PALETTE = {
	orange: '#f18e44',
	black: '#1d1d1b',
	cream: '#f9e7c8',
	offWhite: '#f0eee7',
	red: '#ea512f',
	jungle: '#405a53',
	khaki: '#9d9b79',
	// The website's own accents, kept because the brand book's orange and black read differently there.
	webOrange: '#ff7e1d',
	webOrangeStrong: '#f66900',
	webInk: '#25302c',
} as const;

export type BrandColor = keyof typeof BRAND_PALETTE;
